import React, { useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { openTooltip } from "../../../store/actions";
import { isTouchScreen } from "../../../lib/elementUtilities";

interface IProps {
  classes: string;
  icon: string;
  tooltipOptions: any;
  click?: boolean;
  hover?: boolean;
}

const mapDispatchToProps = (dispatch: any) => ({
  openTooltipDispatch: (tooltipOptions: any) => dispatch(openTooltip(tooltipOptions))
});

const connector = connect(null, mapDispatchToProps);

const NewsIcon = ({
  classes,
  icon,
  tooltipOptions,
  click,
  hover,
  openTooltipDispatch,
}: IProps & ConnectedProps<typeof connector>) => {
  const newsIconRef = useRef<HTMLAnchorElement>(null);

  return (<a
    ref={newsIconRef}
    onMouseEnter={() => hover && !isTouchScreen() && openTooltipDispatch({
      ...tooltipOptions,
      elementRef: newsIconRef
    })}
    onClick={() => (click || isTouchScreen()) && openTooltipDispatch({
      ...tooltipOptions,
      elementRef: newsIconRef
    })}
    className={`new-item ${classes}`}
  >
    <span className={`icon icon-${icon} icon-lg icon-standalone`}/>
  </a>)
}

export default connector(NewsIcon);
